import { QueryResult, MfaType } from "common";

export enum UserDbRole {
  ADMIN = "administrator",
  USER = "user",
  DEVELOPER = "developer"
}

export interface BrokerUserData {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: UserDbRole;
  brokerId: number;
  mobilePhone: string;
  active: boolean;
  status: BrokerUserStatus;
  mfaType: MfaType;
}

export enum BrokerUserStatus {
  None = "none",
  Invited = "invited",
  Active = "active",
  Disabled = "disabled"
}

export const BrokerUserStatusLabel = new Map<BrokerUserStatus, string>([
  [BrokerUserStatus.None, "None"],
  [BrokerUserStatus.Invited, "Invited"],
  [BrokerUserStatus.Active, "Active"],
  [BrokerUserStatus.Disabled, "Disabled"],
]);

export type BrokerProfileData = Pick<
  BrokerUserData,
  "firstName" | "lastName" | "mobilePhone"
>;

export type BrokerEditUserData = Omit<BrokerUserData, "id" | "status">;

export interface BrokerDataDetails {
  advisorId: number;
  name: string;
  apiEnabled: boolean;
}

export interface BrokerPasswordChangeRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface BrokerUsersQueryResult extends QueryResult<BrokerUserData> {}
